import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Header } from "@datagame/ui";
import { AuthPageLayout } from "../../../components/account/AuthPageLayout";
import { InviteForm } from "../../../components/account/InviteForm";
import { Navigation } from "../../../components/account/Navigation";

import styles from "./InvitePage.module.scss";

export const InvitePage = () => {
  const { t } = useTranslation("account");
  const [activeStep, setActiveStep] = useState(1);
  const steps = [1, 2, 3];
  const [searchParams] = useSearchParams();

  const name = searchParams.get("name") ?? "undefined";

  const handleBack = () => {
    if (activeStep === 1) {
      return;
    }
    setActiveStep(activeStep - 1);
  };

  return (
    <AuthPageLayout>
      <div>
        <Navigation steps={steps} activeStep={activeStep} onBack={handleBack} />
        <Header variant="h5" className={styles.h5}>
          {t("invitePage.header")}
        </Header>
        <Header variant="h1" className={styles.header}>
          {t("invitePage.inviteTo", { companyName: name?.toUpperCase() })}{" "}
          <span className={styles.orangeText}>{t("invitePage.company")}</span>
        </Header>
      </div>
      <InviteForm step={activeStep} changeStep={setActiveStep} />
    </AuthPageLayout>
  );
};
